import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=16eb37d0&scoped=true&"
import script from "./SideNav.vue?vue&type=script&lang=js&"
export * from "./SideNav.vue?vue&type=script&lang=js&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=16eb37d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eb37d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16eb37d0')) {
      api.createRecord('16eb37d0', component.options)
    } else {
      api.reload('16eb37d0', component.options)
    }
    module.hot.accept("./SideNav.vue?vue&type=template&id=16eb37d0&scoped=true&", function () {
      api.rerender('16eb37d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/SideNav.vue"
export default component.exports